import httpClient from "./httpClient";

// Device maps
export function listDeviceMaps(subjectType) {
  const path = subjectType === "STAFF" ? "staff" : "students";
  return httpClient.get(`/attendance/device-maps/${path}`).then((res) => res.data.data);
}
export function createDeviceMap(subjectType, payload) {
  const path = subjectType === "STAFF" ? "staff" : "students";
  return httpClient.post(`/attendance/device-maps/${path}`, payload).then((res) => res.data.data);
}
export function deleteDeviceMap(subjectType, id) {
  const path = subjectType === "STAFF" ? "staff" : "students";
  return httpClient.delete(`/attendance/device-maps/${path}/${id}`).then((res) => res.data);
}
export function listDisabledStaffDeviceMaps() {
  return httpClient.get("/attendance/device-maps/staff/disabled").then((res) => res.data.data);
}

// Period / staff time config
export function listPeriodTimeConfigs() {
  return httpClient.get("/attendance/config/period-time").then((res) => res.data.data);
}
export function savePeriodTimeConfig(payload) {
  return httpClient.post("/attendance/config/period-time", payload).then((res) => res.data.data);
}
export function deletePeriodTimeConfig(id) {
  return httpClient.delete(`/attendance/config/period-time/${id}`).then((res) => res.data);
}
export function listStaffTimeConfigs() {
  return httpClient.get("/attendance/config/staff-time").then((res) => res.data.data);
}
export function saveStaffTimeConfig(payload) {
  return httpClient.post("/attendance/config/staff-time", payload).then((res) => res.data.data);
}
export function deleteStaffTimeConfig(id) {
  return httpClient.delete(`/attendance/config/staff-time/${id}`).then((res) => res.data);
}

// Student attendance
export function getStudentAttendanceGrid(classConfigurationId, periodId, date, academicYear) {
  return httpClient
    .get("/attendance/students", { params: { classConfigurationId, periodId, date, academicYear } })
    .then((res) => res.data.data);
}
export function saveStudentAttendance(payload) {
  return httpClient.post("/attendance/students", payload).then((res) => res.data.data);
}
export function processStudentDeviceLog(payload) {
  return httpClient.post("/attendance/students/process-device-log", payload).then((res) => res.data);
}
export function uploadStudentDeviceLog(file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post("/attendance/students/upload-device-log", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data);
}

// Staff attendance
export function getStaffAttendanceGrid(date) {
  return httpClient.get("/attendance/staff", { params: { date } }).then((res) => res.data.data);
}
export function saveStaffAttendance(payload) {
  return httpClient.post("/attendance/staff", payload).then((res) => res.data.data);
}
export function processStaffDeviceLog(payload) {
  return httpClient.post("/attendance/staff/process-device-log", payload).then((res) => res.data);
}
export function uploadStaffDeviceLog(file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post("/attendance/staff/upload-device-log", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data);
}

// Leaves
export function listLeaves(params) {
  return httpClient.get("/leaves", { params }).then((res) => res.data.data);
}
export function createLeave(payload) {
  return httpClient.post("/leaves", payload).then((res) => res.data.data);
}
export function cancelLeave(id) {
  return httpClient.delete(`/leaves/${id}`).then((res) => res.data);
}

// Holidays
export function listWeeklyHolidays() {
  return httpClient.get("/holidays/weekly").then((res) => res.data.data);
}
export function createWeeklyHoliday(payload) {
  return httpClient.post("/holidays/weekly", payload).then((res) => res.data.data);
}
export function deleteWeeklyHoliday(id) {
  return httpClient.delete(`/holidays/weekly/${id}`).then((res) => res.data);
}
export function listOthersHolidays() {
  return httpClient.get("/holidays/others").then((res) => res.data.data);
}
export function createOthersHoliday(payload) {
  return httpClient.post("/holidays/others", payload).then((res) => res.data.data);
}
export function deleteOthersHoliday(id) {
  return httpClient.delete(`/holidays/others/${id}`).then((res) => res.data);
}

// Scheduler config
export function listSchedulerConfigs() {
  return httpClient.get("/scheduler-config").then((res) => res.data.data);
}
export function saveSchedulerConfig(payload) {
  return httpClient.post("/scheduler-config", payload).then((res) => res.data.data);
}
